import React, { Component } from 'react'

export default class Report extends Component {
    getContent = (items) =>{
        let result = []

        if(items !== undefined && items !== null)
            items.forEach((element) => {
                if(element.value === undefined){
                    if(element.label !== "space")
                        result.push(element.label);
                }else if(element.value !== null) 
                    result.push(element.label + ": " + element.value)
                
                if(element.value !== null) 
                    result.push(<br key={Math.random()}/>);
            });

        return result;
    }

    render() {
        return (
            <div className="summary_uicontrol">
                <p className="summary">
                    <strong>Progetto</strong>
                    <br/>
                    {this.getContent(this.props.items)}
                </p>
            </div>
        )
    }
}
